import React from 'react';
import { contactConfig } from '../config/contactConfig';

const TopBanner = () => {
    return (
        <div className="fixed top-0 left-0 right-0 w-full bg-white border-b border-gray-100 py-2 z-[60]">
            <div className="flex items-center justify-center gap-3 text-sm">
                {/* Mobil: telefon numarası kat içinde görünür — acil arama niyeti için */}
                <a
                    href={`tel:${contactConfig.phone}`}
                    className="sm:hidden font-semibold text-primary hover:text-primary-dark transition-colors duration-200"
                    aria-label={`7/24 Acil Kepenk Servisi — ${contactConfig.phoneDisplay} numarasını ara`}
                >
                    7/24 Acil Servis: {contactConfig.phoneDisplay}
                </a>
                <a
                    href="https://www.armahangroup.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hidden sm:block text-primary hover:text-primary-dark transition-colors duration-200 hover:bg-gray-50"
                >
                    Güven Kepenk, <strong>Armahan Group Mimarlık LTD. ŞTİ.</strong> bünyesinde faaliyet göstermektedir.
                    <span className="ml-1 text-xs opacity-70">↗</span>
                </a>
                <a
                    href={`tel:${contactConfig.phone}`}
                    className="hidden sm:inline font-semibold text-primary hover:text-primary-dark transition-colors duration-200"
                    aria-label={`Telefonla ara: ${contactConfig.phoneDisplay}`}
                >
                    ☎ {contactConfig.phoneDisplay}
                </a>
            </div>
        </div>
    );
};

export default TopBanner;
